import React from 'react';
import classNames from 'classnames';

import css from './IconClose.module.css';
const SIZE_SMALL = 'small';

/**
 * Close icon. "x"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @param {'small' | null} props.size
 * @returns {JSX.Element} SVG icon
 */
const IconClose = props => {
  const { className, rootClassName, size } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (size === SIZE_SMALL) {
    return (
      <svg className={classes} width="9" height="9" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.175 8.396l2.482-2.482 2.482 2.482a.889.889 0 1 0 1.258-1.257L5.914 4.657l2.482-2.483A.89.89 0 0 0 7.139.917L4.657 3.4 2.175.918A.888.888 0 1 0 .917 2.174L3.4 4.657.918 7.139a.889.889 0 1 0 1.257 1.257"
          fillRule="evenodd"
        />
      </svg>
    );
  }

  return (
    <svg className={classes} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.4941 16.2559C17.5754 16.3372 17.6398 16.4337 17.6838 16.54C17.7278 16.6462 17.7505 16.76 17.7505 16.875C17.7505 16.99 17.7278 17.1038 17.6838 17.21C17.6398 17.3163 17.5754 17.4128 17.4941 17.4941C17.4128 17.5754 17.3163 17.6398 17.21 17.6838C17.1038 17.7278 16.99 17.7505 16.875 17.7505C16.76 17.7505 16.6462 17.7278 16.54 17.6838C16.4337 17.6398 16.3372 17.5754 16.2559 17.4941L9 10.237L1.74406 17.4941C1.57988 17.6582 1.35719 17.7505 1.125 17.7505C0.892805 17.7505 0.670121 17.6582 0.505936 17.4941C0.34175 17.3299 0.249512 17.1072 0.249512 16.875C0.249512 16.6428 0.34175 16.4201 0.505936 16.2559L7.76297 9L0.505936 1.74406C0.34175 1.57988 0.249512 1.35719 0.249512 1.125C0.249512 0.892807 0.34175 0.670123 0.505936 0.505938C0.670121 0.341752 0.892805 0.249514 1.125 0.249514C1.35719 0.249514 1.57988 0.341752 1.74406 0.505938L9 7.76297L16.2559 0.505938C16.4201 0.341752 16.6428 0.249514 16.875 0.249514C17.1072 0.249514 17.3299 0.341752 17.4941 0.505938C17.6582 0.670123 17.7505 0.892807 17.7505 1.125C17.7505 1.35719 17.6582 1.57988 17.4941 1.74406L10.237 9L17.4941 16.2559Z" fill="#052E65" />
    </svg>

  );
};

export default IconClose;
